function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import parseSpeed from "./util/parse-speed.js";
import calculateSignificantScrollDistance from "./util/calculate-significant-scroll-distance.js";
import { add, remove } from "./util/scroll-watcher.js";
const ParallaxLayer = styled.div.withConfig({
  componentId: "sc-g2rjte-0"
})(["backface-visibility:hidden;position:relative;will-change:transform;height:100%;"]);

const Parallax = _ref => {
  let {
    on = "exit",
    speed = "-1",
    children,
    ...props
  } = _ref;
  const [dY, setDY] = useState(0);
  const [lastTop, setLastTop] = useState(0); // handle refs

  const baseNode = useRef(null);
  const layerNode = useRef(null);
  useEffect(() => {
    const calculate = () => {
      const {
        top: baseTop,
        bottom: baseBottom
      } = baseNode.current.getBoundingClientRect();
      const {
        bottom: layerBottom
      } = layerNode.current.getBoundingClientRect();
      const vpHeight = window.outerHeight;
      const significantScrollDistance = calculateSignificantScrollDistance({
        on,
        vpHeight,
        baseTop
      });
      const speedCoefficient = parseSpeed(speed); // only set state if target element hasn't left viewport to top
      // or if it has, if we're scrolling in reverse and the new DY is bigger

      if (layerBottom > 0 || baseBottom > 0 && lastTop < baseTop) {
        // this.setState({dY})
        requestAnimationFrame(() => setDY((speedCoefficient * significantScrollDistance).toFixed(4)));
      }

      setLastTop(baseTop);
    };

    calculate();
    add(calculate);
    return () => {
      remove(calculate);
    };
  }, [lastTop, on, speed]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: baseNode
  }, props), /*#__PURE__*/React.createElement(ParallaxLayer, {
    ref: layerNode,
    style: {
      transform: `translateY(${dY}px)`
    }
  }, children));
};

Parallax.propTypes = {
  /** Content to add parallax effects to */
  children: PropTypes.node.isRequired,

  /** When parallaxing effects begin - when exiting viewport, entering viewport, or on load even if not in viewport */
  on: PropTypes.oneOf(["exit", "enter", "load"]),

  /** Parallax effect speed where negative speeds mean slower than scroll speed */
  speed: PropTypes.oneOf(["-5", "-4", "-3", "-2", "-1", "1", "2", "3", "4", "5"])
};
export default Parallax;